"use client";

import { MediaCategoryDataRes } from "@/types/media";
import { create } from "zustand";
import { persist } from "zustand/middleware";


type MediaCategoryState = {
  categories: MediaCategoryDataRes[];
  categoryMap: Map<string, MediaCategoryDataRes>;
  setCategories: (data: MediaCategoryDataRes[]) => void;
  getByParent: (parent: string) => MediaCategoryDataRes[];
  getById: (id: string) => MediaCategoryDataRes | undefined;
};

export const useMediaCategoryStore = create<MediaCategoryState>()(
  persist(
    (set, get) => ({
      categories: [],
      categoryMap: new Map<string, MediaCategoryDataRes>(),

      setCategories: (data) => {
        const map = new Map<string, MediaCategoryDataRes>();
        data.forEach((item) => map.set(item.id, item));
        set({ categories: data, categoryMap: map });
      },

      getByParent: (parent) =>
        get().categories.filter((i) => i.parent_cd === parent),

      getById: (id) => get().categoryMap.get(id),
    }),
    {
      name: "media-category-store", // key in localStorage
      partialize: (state) => ({ categories: state.categories }),
      onRehydrateStorage: () => (state) => {
        if (state?.categories) {
          const map = new Map<string, MediaCategoryDataRes>();
          state.categories.forEach((item) => map.set(item.id, item));
          state.categoryMap = map;
        }
      },
    }
  )
);
